import { useContext } from "react";
import { QuestionnaireListContext } from "./context";

export const useQuestionnaireListContext = () => {
    const context = useContext(QuestionnaireListContext);

    if (context) {
        return context;
    }

    throw new Error(`useQuestionnaireList must be used within the context`);
};
